import { useCallback } from "react";

import { VcsProvider } from "types/generated";
import useDeleteAzureDevOpsIntegration from "views/Account/VCS/Integrations/ManageAzureDevOps/useDeleteAzuredevOpsIntegration";
import useDeleteBitbucketCloudIntegration from "views/Account/VCS/Integrations/ManageBitbucketCloud/useDeleteBitbucketCloudIntegration";
import useDeleteBitbucketDataCenterIntegration from "views/Account/VCS/Integrations/ManageBitbucketDataCenter/useDeleteBitbucketDataCenterIntegration";
import useDeleteGitHubIntegration from "views/Account/VCS/Integrations/ManageGitHubEnterprise/useDeleteGitHubEnterpriseIntegration";
import useDeleteGitLabIntegration from "views/Account/VCS/Integrations/ManageGitLab/useDeleteGitLabIntegration";

const useDeleteVcsIntegration = () => {
  const { deleteGitHubEnterpriseIntegration, loading: gitHubLoading } =
    useDeleteGitHubIntegration();
  const { deleteGitLabIntegration, loading: gitLabLoading } = useDeleteGitLabIntegration();
  const { deleteAzureDevOpsIntegration, loading: azureLoading } = useDeleteAzureDevOpsIntegration();
  const { deleteBitbucketDataCenterIntegration, loading: bitbucketDataCenterLoading } =
    useDeleteBitbucketDataCenterIntegration();
  const { deleteBitbucketCloudIntegration, loading: bitbucketCloudLoading } =
    useDeleteBitbucketCloudIntegration();

  const handleDeleteVcsIntegration = useCallback(
    (
      id: string,
      provider: VcsProvider,
      totalUsedByEntitiesQty: number,
      successCallback?: () => void
    ) => {
      if (provider === VcsProvider.GithubEnterprise) {
        return deleteGitHubEnterpriseIntegration(id, totalUsedByEntitiesQty, successCallback);
      }

      if (provider === VcsProvider.Gitlab) {
        return deleteGitLabIntegration(id, totalUsedByEntitiesQty, successCallback);
      }

      if (provider === VcsProvider.AzureDevops) {
        return deleteAzureDevOpsIntegration(id, totalUsedByEntitiesQty, successCallback);
      }

      if (provider === VcsProvider.BitbucketDatacenter) {
        return deleteBitbucketDataCenterIntegration(id, totalUsedByEntitiesQty, successCallback);
      }

      if (provider === VcsProvider.BitbucketCloud) {
        return deleteBitbucketCloudIntegration(id, totalUsedByEntitiesQty, successCallback);
      }

      return;
    },
    [
      deleteAzureDevOpsIntegration,
      deleteBitbucketCloudIntegration,
      deleteBitbucketDataCenterIntegration,
      deleteGitHubEnterpriseIntegration,
      deleteGitLabIntegration,
    ]
  );

  return {
    deleteVcsIntegration: handleDeleteVcsIntegration,
    loading:
      gitHubLoading ||
      gitLabLoading ||
      azureLoading ||
      bitbucketDataCenterLoading ||
      bitbucketCloudLoading,
  };
};

export default useDeleteVcsIntegration;
